import React, { useContext, Suspense } from 'react';
import LazyLoad from 'react-lazy-load';
import PropTypes from 'prop-types';
import Head from 'next/head'
import ImageFactory from '../../adapters/cloudinary/ImageFactory';
import { ICloudinaryImage } from '../../types';
import { optimizeImage } from '../../adapters/helpers/pagespeedHelper';
import { ImageConstants, ImageContenfullConstants, ComponentFactoryConstants} from '../../adapters/helpers/Constants';
import Loader from '../../adapters/helpers/Loader';
import Image from 'next/image';

const Visibility = React.createContext(false);

export default function Backdrop(props) {
    const content = (
        <div {...props} className={`${props.className || ''} ob-backdrop`} />
    );

    return (
        <Suspense fallback={<Loader />}>
        <LazyLoad offset={500} placeholder={
            <Visibility value={false}>
                {content}
            </Visibility>
        }>
            <Visibility value={true}>
                {content}
            </Visibility>
        </LazyLoad>
        </Suspense>
    );
}

Backdrop.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
};

Backdrop.Image = BackdropImage;
function BackdropImage({
    preserveAspectRatio = true,
    className = '',
    image, xlg = image, lg = xlg, md = lg, sm = md,
    mobileImage = sm, xs = mobileImage, tiny = xs, xtiny = tiny,
}) {
    const visible = useContext(Visibility);
    const ispreload = mobileImage?.fields?.isPreload
    const isBannerImage = mobileImage?.fields?.isBannerImage
    const fallback = image || xlg || lg || md || sm || xs || tiny || xtiny;
    let mobileImageAssetID =  mobileImage?.fields?.asset?.fields?.file?.url;
    let desktopImageAssetID = image?.fields?.asset?.fields?.file?.url;  
    const preloadMobileImageUrl = ImageFactory.buildContentfullImageUrl(mobileImageAssetID, ImageConstants.preload_image_transformations);
    const preloadDesktopImageUrl = ImageFactory.buildContentfullImageUrl(desktopImageAssetID, ImageConstants.preload_image_transformations);
    
    return (
        <div className={`${className} ob-backdrop__image`}>
            {ispreload && isBannerImage && <Head>
                 <link rel='preload' href='/static/fonts/Neutraface2Text-Bold.woff2' as='font' crossOrigin='anonymous' fetchPriority='high' />
                 <link rel='preload' href='/static/fonts/Neutraface2Text-Light.woff2' as='font' crossOrigin='anonymous' fetchPriority='high' />
                 <link rel="preload" href={preloadMobileImageUrl} as="image" media={`(max-width:${ImageConstants.mobile_max_width})`} fetchPriority='high' />
                 <link rel="preload" href={preloadDesktopImageUrl} as="image" media={`(min-width:${ImageConstants.desktop_min_width})`} fetchPriority='high' />
                
            </Head> }
            {!!preserveAspectRatio && (<>
                {!!xlg      && renderAspectRatio(xlg, 'xlg')}
                {!!lg       && renderAspectRatio(lg, 'lg')}
                {!!md       && renderAspectRatio(md, 'md')}
                {!!sm       && renderAspectRatio(sm, 'sm')}
                {!!xs       && renderAspectRatio(xs, 'xs')}
                {!!tiny     && renderAspectRatio(tiny, 'tiny')}
                {!!xtiny    && renderAspectRatio(xtiny, 'xtiny')}
            </>)}

            <picture className="ob-backdrop__pic">
                {/* {!!xlg   && <source srcSet={ImageFactory.dpr(xlg,  'f_auto,q_auto,w_1440')} media="(min-width: 1440px)" />}
                {!!lg    && <source srcSet={ImageFactory.dpr(lg,   'f_auto,q_auto,w_1200')} media="(min-width: 1200px)" />}
                {!!md    && <source srcSet={ImageFactory.dpr(md,    'f_auto,q_auto,w_992')} media="(min-width: 992px)"  />}
                {!!sm    && <source srcSet={ImageFactory.dpr(sm,    'f_auto,q_auto,w_768')} media="(min-width: 768px)"  />}
                {!!xs    && <source srcSet={ImageFactory.dpr(xs,    'f_auto,q_auto,w_426')} media="(min-width: 426px)"  />}
                {!!tiny  && <source srcSet={ImageFactory.dpr(tiny,  'f_auto,q_auto,w_376')} media="(min-width: 376px)"  />}
                {!!xtiny && <source srcSet={ImageFactory.dpr(xtiny, 'f_auto,q_auto,w_365')}                             />} */}

                {!!xlg   && <source srcSet={ImageFactory.imageContentfullDpr(xlg?.fields?.asset?.fields?.file?.url, ImageContenfullConstants.dpr_1440)} media={ComponentFactoryConstants.mediaUpper} />}
                {!!lg    && <source srcSet={ImageFactory.imageContentfullDpr(lg?.fields?.asset?.fields?.file?.url,  ImageContenfullConstants.dpr_1200)} media={ImageContenfullConstants.media_1200} />}
                {!!md    && <source srcSet={ImageFactory.imageContentfullDpr(md?.fields?.asset?.fields?.file?.url,  ImageContenfullConstants.dpr_992)} media={ImageContenfullConstants.media_992}  />}
                {!!sm    && <source srcSet={ImageFactory.imageContentfullDpr(sm?.fields?.asset?.fields?.file?.url,  ImageContenfullConstants.dpr_768)} media={ImageContenfullConstants.media_768}  />}
                {!!xs    && <source srcSet={ImageFactory.imageContentfullDpr(xs?.fields?.asset?.fields?.file?.url,  ImageContenfullConstants.dpr_426)} media={ComponentFactoryConstants.mediaUpper}  />}
                {!!tiny  && <source srcSet={ImageFactory.imageContentfullDpr(tiny?.fields?.asset?.fields?.file?.url,  ImageContenfullConstants.dpr_376)} media={ImageContenfullConstants.media_376}  />}
                {!!xtiny && <source srcSet={ImageFactory.imageContentfullDpr(xtiny?.fields?.asset?.fields?.file?.url, ImageContenfullConstants.dpr_365)}  />}                                   

                {(visible && fallback) ? (
                    <Image
                        className="ob-backdrop__img"
                        alt={fallback.fields.alternateText || ''}
                        src={optimizeImage(ImageFactory.imageContentfullSrc(fallback?.fields?.asset?.fields?.file?.url, ImageContenfullConstants.dpr_1440))}
                        srcSet={optimizeImage(ImageFactory.imageContentfullDpr(fallback?.fields?.asset?.fields?.file?.url, ImageContenfullConstants.dpr_1440))}
                        priority={true}
                        width={0}
                        height={0}
                        style={{width: 'auto', height: 'auto'}}
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    />
                ) : ispreload && isBannerImage && <Image
                className="ob-backdrop__img"
                alt={fallback.fields.alternateText || ''}
                src={optimizeImage(ImageFactory.imageContentfullSrc(fallback?.fields?.asset?.fields?.file?.url, ImageContenfullConstants.dpr_1440))}
                srcSet={optimizeImage(ImageFactory.imageContentfullDpr(fallback?.fields?.asset?.fields?.file?.url, ImageContenfullConstants.dpr_1440))}
                priority={true}
                width={0}
                height={0}
                style={{width: 'auto', height: 'auto'}}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />}
            </picture>
        </div>
    );
}

BackdropImage.propTypes = {
    className: PropTypes.string,
    alt: PropTypes.string,
    image: ICloudinaryImage,
    mobileImage: ICloudinaryImage,
    xtiny: ICloudinaryImage,
    tiny: ICloudinaryImage,
    xs: ICloudinaryImage,
    sm: ICloudinaryImage,
    md: ICloudinaryImage,
    lg: ICloudinaryImage,
    xlg: ICloudinaryImage,
    preserveAspectRatio: PropTypes.bool,
};

Backdrop.Content = BackdropContent;
function BackdropContent({ className, children = null}) {
    return (
        <div className={`${className || ''} ob-backdrop__content`}>
            {children}
        </div>
    );
}

BackdropContent.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

function renderAspectRatio(image, breakpointKey) {
    const aspectRatio = image?.fields?.imageRendition?.fields?.aspectRatio;

    if (!aspectRatio) {
        return null;
    }

    return (
        <div
            className={`ob-backdrop__ratio ob-backdrop__ratio--${breakpointKey}`}
            style={{ paddingTop: 100 / aspectRatio + '%' }}
        />
    );
}